import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Form,
  FormGroup,
  FormField,
  Input,
  Label
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardDrugPickingOrderUX = (props: any) => {
    return(
      <div
        id="CardDrugPickingOrderUX-div-0"
        style={{ width : "100%", height: "100%" }}>
        <Segment
          className="segment-no-shadow"
          id="CardDrugPickingOrderUX-Segment-1">
          <div
            id="CardDrugPickingOrderUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <div
              id="CardDrugPickingOrderUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.15rem"}}>
              {props.languageUX === "en" ? "Additional drug list within the clinic/unit" : "รายการยาเพิ่มเติมภายในหน่วยตรวจ"}
            </div>
            <div
              id="CardDrugPickingOrderUX-div-12"
              style={{cursor: "pointer"}}>
              
            </div>
          </div>
          <Form
            id="CardDrugPickingOrderUX-Form-13">
            <FormGroup
              id="CardDrugPickingOrderUX-FormGroup-14"
              inline={true}
              style={{marginTop: "1.25rem"}}>
              <FormField
                id="CardDrugPickingOrderUX-FormField-15"
                inline={true}
                width={6}>
                <label
                  id="CardDrugPickingOrderUX-label-18"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Product name or code" : "ชื่อหรือรหัสสินค้า"}
                </label>
                <Input
                  fluid={true}
                  id="CardDrugPickingOrderUX-Input-19"
                  name="keyword"
                  onChange={props.onChangeFilter}
                  size="small"
                  value={props.filter?.keyword || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardDrugPickingOrderUX-FormField-16"
                inline={true}>
                <div
                  id="CardDrugPickingOrderUX-div-22">
                  {props.ButtonSearch}
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardDrugPickingOrderUX-div-20">
            
            <Table
              data={props.drugPickingData || []}
              headers=",Generic name,Drug name,Form,Strength/Contain"
              id="CardDrugPickingOrderUX-Table-21"
              keys="_add,generic_name,name,dosage_form_name,size"
              minRows={5}
              showPagination={false}
              style={{height: "210px"}}
              widths="70,^200,^175,^100,^100">
            </Table>
          </div>
          <div
            className="ui divider"
            id="CardDrugPickingOrderUX-div-23"
            style={{margin:"1.25rem 0"}}>
            
          </div>
          <div
            id="CardDrugPickingOrderUX-div-24">
            {props.TabPans}
          </div>
          <div
            id="CardDrugPickingOrderUX-div-29"
            style={{display: props.selectedPickingOrder?.id?"flex":"none", alignItems: "center", margin: "0.75rem 0 -0.5rem"}}>
            
            <Label
              color="black"
              id="CardDrugPickingOrderUX-Label-30">
              {`PICKING: ${props.selectedPickingOrder?.code || "-"}`}
            </Label>
            <div
              id="CardDrugPickingOrderUX-div-31"
              style={{flex: 1}}>
              
            </div>
            <Label
              id="CardDrugPickingOrderUX-Label-32"
              style={{minWidth: "6rem", textAlign: "center", backgroundColor: props.statusColor, color: "white" }}>
              {`${props.selectedPickingOrder?.status_label || "-"}`}
            </Label>
          </div>
          <div
            id="CardDrugPickingOrderUX-div-25"
            style={{marginTop: "1rem"}}>
            
            <Table
              data={props.drugPickingOrderItemsData || []}
              headers="Drug name,Dose,Unit,Route,Site,Method,Qty,"
              id="CardDrugPickingOrderUX-Table-26"
              keys="name,dose,code_unit,code_route,code_site,code_method,quantity,_remove"
              minRows={5}
              showPagination={false}
              style={{height: "210px"}}
              widths="^175,^80,^100,^100,^100,^100,^80,70">
            </Table>
          </div>
          <div
            id="CardDrugPickingOrderUX-div-27"
            style={{display: "flex", justifyContent: "flex-end", marginTop: "1rem"}}>
            
            <div
              id="CardDrugPickingOrderUX-div-28">
              {props.ButtonSave}
            </div>
          </div>
        </Segment>
      </div>
    )
}


export default CardDrugPickingOrderUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","language":"EN","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Oct 31 2025 11:33:00 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "segment-no-shadow"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการยาเพิ่มเติมภายในหน่วยตรวจ",
          "valueEN": "Additional drug list within the clinic/unit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.15rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Form",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Form-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-FormGroup-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.25rem\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-FormField-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อหรือรหัสสินค้า",
          "valueEN": "Product name or code"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Input",
      "parent": 15,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Input-19"
        },
        "name": {
          "type": "value",
          "value": "keyword"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.keyword || \"\""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 21,
      "name": "Table",
      "parent": 20,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugPickingData || []"
        },
        "headers": {
          "type": "value",
          "value": ",Generic name,Drug name,Form,Strength/Contain"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Table-21"
        },
        "keys": {
          "type": "value",
          "value": "_add,generic_name,name,dosage_form_name,size"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"210px\"}"
        },
        "widths": {
          "type": "value",
          "value": "70,^200,^175,^100,^100"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"1.25rem 0\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.TabPans"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 26,
      "name": "Table",
      "parent": 25,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugPickingOrderItemsData || []"
        },
        "headers": {
          "type": "value",
          "value": "Drug name,Dose,Unit,Route,Site,Method,Qty,"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Table-26"
        },
        "keys": {
          "type": "value",
          "value": "name,dose,code_unit,code_route,code_site,code_method,quantity,_remove"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"210px\"}"
        },
        "widths": {
          "type": "value",
          "value": "^175,^80,^100,^100,^100,^100,^80,70"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSave"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-28"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedPickingOrder?.id?\"flex\":\"none\", alignItems: \"center\", margin: \"0.75rem 0 -0.5rem\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Label",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "`PICKING: ${props.selectedPickingOrder?.code || \"-\"}`"
        },
        "color": {
          "type": "value",
          "value": "black"
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Label-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Label",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "`${props.selectedPickingOrder?.status_label || \"-\"}`"
        },
        "color": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugPickingOrderUX-Label-32"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"6rem\", textAlign: \"center\", backgroundColor: props.statusColor, color: \"white\" }"
        }
      },
      "seq": 32,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugPickingOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "language": "EN",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
